import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-pdf-writer-lib',
  template: `
    <p>
      pdf-writer-lib works!
    </p>
  `,
  styles: []
})
export class PdfWriterLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
